"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var useSidebar_1 = require("../hooks/useSidebar");
exports.Editable = function (_a) {
    var children = _a.children, block = _a.block;
    var child = react_1.default.Children.only(children);
    var editableFields = child.type.editableFields;
    var ref = react_1.useRef(null);
    var returnFocus = function () {
        if (ref.current) {
            ref.current.focus();
        }
    };
    var ctx = react_1.useContext(useSidebar_1.EditContext);
    var onClick = function () {
        ctx.pushSidebarItem({
            block: block,
            fields: editableFields
        });
    };
    var onActivate = function () {
        ctx.pushSidebarItem({
            block: block,
            fields: editableFields,
            returnFocus: returnFocus
        });
    };
    var requiredProps = {
        onClick: onClick,
        onKeyPress: function (e) {
            if (e.nativeEvent.key === "Enter") {
                onActivate();
            }
        },
        ref: ref,
        tabIndex: 0
    };
    if (child.type.editableContainer) {
        return react_1.createElement(child.type.editableContainer, __assign(__assign({}, requiredProps), { children: react_1.cloneElement(child, { onClick: function () { }, tabIndex: -1 }) }));
    }
    return (react_1.default.createElement(creator_ui_1.Box, __assign({ p: "10px", border: "1px solid #eee", style: { alignSelf: "center" }, width: block.type === "ContinueButton" ? "auto" : "100%" }, requiredProps), react_1.cloneElement(child, { onClick: function () { }, tabIndex: -1 })));
};
